import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "swiper/css";
import "swiper/css/navigation";
import "./Programs.css";
import axios from "axios";

const News = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  // Replace with your actual API URL
  const apiUrl = "https://isbmuniversity.edu.in/admin-portal/newsApi";
  const imageBaseUrl =
    "https://isbmuniversity.edu.in/admin-portal/admin-assets/news-banners/";

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await axios.get(apiUrl);
        const fetchedData = res?.data?.data || [];

        // If your API doesn't provide `link` and `alt`, generate them
        const formattedEvents = fetchedData.map((item) => ({
          id: item.id,
          title: item.title,
          image: imageBaseUrl + item.banner,
          link: `/news-details/${item.id}`,
          alt: item.title,
        }));

        setEvents(formattedEvents);
      } catch (error) {
        console.error("Failed to fetch events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const news_slider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="color-section ptb-50">
      <div className="container-xxl">
        <section className="happening_section">
          <h2 className="modern-title mb-4"><span>Campus Chronicles: </span>Latest Highlights <br></br> and Campus Updates</h2>
          {loading ? (
            <p className="text-center">Loading...</p>
          ) : events.length === 0 ? (
            <p className="text-center">No happenings found.</p>
          ) : (
            <Slider {...news_slider} className="blogSwiper">
              {events.map((event, index) => (
                <div className="p-3" key={event.id}>
                  <div className="happening_Bx">
                    <figure>
                      <img
                        src={event.image}
                        alt={event.alt}
                        width="292"
                        height="119"
                        className="img-fluid image reveal-image"
                      />
                    </figure>

                    <div className="team-info">
                      <p className="short-title mb-0">{event.title}</p>
                    </div>

                    <a
                      href={event.link}
                      aria-label="happening"
                      className="stretched-link"
                    ></a>

                    <div className="team-overlay d-flex flex-column justify-content-center align-items-center text-center">
                      <h4 className="text-white mb-3 h5">{event.title}</h4>
                      <Link
                        className="btn btn-sm btn-light text-purple fw-bold"
                        to={`/news-details/${event.id}`}
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          )}
        </section>
      </div>
    </section>
  );
};

export default News;
